<template>
    <div class="string text-4xl" ref="parallaxText" 
    :data-scroll="scrollTop" 
    :position="elementPosition"
    :height="maxHeight"
    :class="isPage ? ( getScreenHeight > elementPosition + 600 ? 'is-active' : 'no-active') 
    : (elementPosition < containerRec.height ? 'isactive' : 'opacity-0')
    ">
        <slot></slot>
    </div>
</template>

<script>

import {onIntersect} from "../../scripts/onintersect"
export default {
    name: "parallax-text",
    props: {
        scrollTop: {
            type: Number,
            default: 0
        },
        container: {
            type: Object,
            default: () => { }
        },
        isPage: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            intersect: false,
            maxHeight: 0,
            elem: null,
            elementPosition: 0,
            posFromTopContainer: 0,
            parentPos: () => { },
            containerRec: () => {},
            parallaxTextRec: () => {},
            lastScrollTop: 0, // Track last scroll position
        }
    },

    computed: {
        getScreenHeight() {
            return window.innerHeight;
        }
    },

    methods: {
        scrollTextInitPage() {
            this.containerRec = this.container.offsetParent.getBoundingClientRect();
            this.maxHeight = this.containerRec.height;
            this.elementPosition = this.$refs.parallaxText.offsetTop;
            const options = {
                root: null,
                rootMargins: '0px',
                threshold: 0.03
            };
            onIntersect(this.$refs.parallaxText, this.handlerEnter, this.handlerOut, false, options);
        },

        handlerEnter(elem) {
            this.intersect = true;
            elem.classList.remove('no-active');
            elem.classList.add('active');
        },

        handlerOut(elem) {
            this.intersect = false;
            elem.classList.remove('active');
            elem.classList.add('no-active');
        },

        handleScroll() {
            requestAnimationFrame(() => {
                this.actualScrollHandler();
            });
        },

        actualScrollHandler() {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (Math.abs(scrollTop - this.lastScrollTop) > 10) { // Throttle updates
                this.lastScrollTop = scrollTop;
                const { elementPosition, elem, maxHeight } = this.$data;
                let max = maxHeight - 150;
                if (scrollTop <= 0 || 300 + scrollTop < elementPosition) {
                    elem.classList.remove('active');
                } else if (scrollTop > elementPosition) {
                    elem.classList.add('active');
                }
            }
        },
    },

    mounted() {
        this.elem = this.$refs.parallaxText;
        this.parallaxTextRec = this.elem.getBoundingClientRect();
        this.containerRec = this.container.getBoundingClientRect();
        this.isPage ? this.scrollTextInitPage() : null;
        window.addEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
.string,.isactive {
    transform: translateY(0);
    transition: .2s cubic-bezier(0.4, 0, 1, 1);
    h1{
        font-size: 40px;
        font-weight: 600;
    }
    h4{
        font-weight: 400;
        font-size: 20px;
    }
    &.active{
        opacity:1;
        transform: translateY(-100px);
        transition: .6s cubic-bezier(0.4, 0, 1, 1);
    }
    &.no-active{
        opacity:0;
        transform: translateY(-0px);
        transition: .2s cubic-bezier(0.4, 0, 1, 1);
    }
}
</style>